import {defineStore} from 'pinia';
import api from '@/apis/fr/frFunctionListAPI.js';
import {BaseDictionaryStore} from '@/stores/baseDictionaryStore';
import {ModuleFormulaCustom} from '@/stores/moduleConst';

const store = new BaseDictionaryStore(api);

export const useFrFunctionListStore = defineStore(ModuleFormulaCustom, {
  state: () => ({
    ...store.state,
    _config: {
      key: 'function_id',
      table: 'fr_function_list',
      moduleName: 'frFunctionList',
    },
    moduleName: 'frFunctionList',
  }),
  actions: {...store.action},
});
